import { buildSectionSequencerStabs, type Section } from '../player/section-sequencer.js'
import { useStabScheduler } from '../player/stab-scheduler.js'

export interface UseFormPlaybackProps {
  sections: readonly Section[] | null
  bpm: number
}

/**
 * Form Visualizer audition hook. Thin wrapper over `useStabScheduler` —
 * delegates the stab math to `buildSectionSequencerStabs`. A null sections
 * payload yields an empty stab list (no-op play), so the host can mount the
 * hook unconditionally regardless of the active phase.
 *
 * Spec: docs/superpowers/specs/2026-05-23-form-visualizer-v1-design.md §5
 */
export const useFormPlayback = (
  props: UseFormPlaybackProps
): { play: () => void; stop: () => void } => {
  const { play, stop } = useStabScheduler({
    buildStabs: () =>
      props.sections
        ? buildSectionSequencerStabs({ sections: props.sections, bpm: props.bpm })
        : [],
  })
  return { play, stop }
}
